import { render } from "./autoComponent.vue?vue&type=template&id=1faa21ea"
import script from "./autoComponent.vue?vue&type=script&lang=ts"
export * from "./autoComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script